export default {
	complete: "Terminer",
	error: "Erreur lors de l'enregistrement. Veuillez réessayer.",
	requiredHint: "Les champs marqués d'un * sont obligatoires.",
	step1: {
		address: "Adresse",
		city: "Ville",
		cnpj: "CNPJ",
		razaoSocial: "Raison sociale",
		state: "État / Région",
		subtitle: "Informations de base sur votre temple",
		title: "Détails du Temple",
		tradition: "Tradition religieuse",
		whatsapp: "WhatsApp",
		zipCode: "Code postal",
	},
	step2: {
		displayName: "Nom complet",
		phone: "Téléphone",
		religiousName: "Nom religieux",
		religiousNameHint: "Ex. : Pai João de Xangô",
		subtitle: "Votre profil dans le temple",
		title: "Vos informations",
		userTitle: "Titre / Fonction",
		userTitleHint: "Ex. : Babalorixá, Mãe de Santo, Dirigeant",
		whatsappOptIn: "Recevoir les avis de l'ORI par WhatsApp",
		whatsappOptInHint:
			"Envoyés depuis le numéro officiel de l'ORI au téléphone ci-dessus. Vous pouvez le désactiver à tout moment dans votre profil.",
	},
	step3: {
		logoUrl: "URL du logo",
		optional: "Cette étape est facultative. Vous pourrez la configurer plus tard.",
		primaryColor: "Couleur principale",
		subtitle: "Identité visuelle du temple",
		title: "Personnalisation",
	},
	step4: {
		title: "Forfait",
		subtitle: "Confirmez votre forfait",
		hint: "Vérifiez le forfait choisi, appliquez un bon si vous en avez un et finalisez l'abonnement.",
		confirmAndPay: "Confirmer et payer",
		decideLater: "Décider plus tard",
	},
	title: "Configuration initiale",
};
